import React from 'react';
import { Tabs as MuiTabs } from '@mui/material';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { props as ApplicationProps } from 'features/eadvisor/application/applicationTypes';

export type tabsOverAllProps = {
    tabsContent: string[];
    value: number;
    handleChange: (event: React.SyntheticEvent, newValue: number) => void;
    appProps: ApplicationProps;
    // renderComponent?: (text: string, props: ApplicationProps) => any;
};
function TabsHeader({ tabsContent, appProps, value, handleChange }: tabsOverAllProps) {
    const mappedContent = tabsContent.map((txt) => {
        const id = txt
            .replace(
                /\[heading\]|\[link\]|\[list\]|\[button\]|\[tooltip\]|\[note\]|\[table\]|\[accordion\]|\[sublist\]|\[paragraph\]|\[tab\]/g,
                ''
            )
            .trim();
        return id;
    });
    const findTabs = appProps?.tabs?.find((tab) => tab.id === mappedContent[0]);

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', p: '0 16px' }}>
                <MuiTabs value={value} onChange={handleChange}>
                    {findTabs?.tabcontents?.map((tab) => {
                        return (
                            <Tab
                                label={tab.title}
                                id={tab.id}
                                data-testid={tab.id}
                                key={tab.id}
                                sx={{ color: '#000', fontWeight: '500', textTransform: 'none' }}
                            />
                        );
                    })}
                </MuiTabs>
            </Box>
        </Box>
    );
}

export default TabsHeader;
